import React from 'react';
import { category1, category2, category3 } from '../../../assets/images';
import { useTranslation } from 'react-i18next';

const Category = () => {

  const { t, i18n } = useTranslation();
  return (
    <div className="md:max-w-container max-w-containerSm mx-auto justify-between mt-[40px] md:mt-[88px]">
      <p className="text-[22px] md:text-[28px] font-semibold text-center mb-10">{t("Kateqoriyalar")}</p>
      <div className="block md:flex justify-between mx-auto md:mx-0">
        {/* Category 1 */}
        <a href='/products'>
        <div className="relative md:w-[427px] md:h-[331px] mb-5 md:mb-0">
          <img src={category1} alt="Category 1" className="w-full h-full object-cover" />
          <p className="absolute top-5 left-5 text-white bg-[#101E65] p-[10px] rounded-[20px] font-medium text-[14px] md:text-[16px]">{t("Professional baxım məhsulları")}</p>
        </div>
        </a>
        {/* Category 2 */}
       <a href='/products'>
       <div className="relative md:w-[527px] md:h-[331px] mb-5 md:mb-0">
          <img src={category2} alt="Category 2" className="w-full h-full object-cover" />
          <p className="absolute top-5 left-5 text-white bg-[#101E65] p-[10px] rounded-[20px] font-medium text-[14px] md:text-[16px]">{t("Set məhsulları")}</p>
        </div>
       </a>
        {/* Category 3 */}
       <a href='/products'>
       <div className="relative md:w-[326px] md:h-[331px]">
          <img src={category3} alt="Category 3" className="w-full h-full object-cover" />
          <p className="absolute top-5 left-5 text-white bg-[#101E65] p-[10px] rounded-[20px] font-medium text-[14px] md:text-[16px]">{t("Ev qulluq məhsulları")}</p>
        </div>
       </a>
      </div>
    </div>
  );
};

export default Category;
